<template>
  <div class="venue-Detail">
    <h3>
      {{ detailInfo.HouseName }}
      <span v-if="detailInfo.ReservationState === 1" style="color:#5cadff;">（待审批）</span>
      <span v-else-if="detailInfo.ReservationState === 3" style="color:#19be6b;">（同意）</span>
      <span v-else-if="detailInfo.ReservationState === 4" style="color:#f05a4a;">（不同意）</span>
      <span v-else-if="detailInfo.ReservationState === 2" style="color:#f90;">（已撤销）</span>
    </h3>
    <p class="line-info">容纳人数：{{ detailInfo.Volume }}</p>
    <p class="line-info">
      场馆地点：{{ detailInfo.SchoolDistrictName }} - {{ detailInfo.BuildingName }} -
      {{ detailInfo.Floor }}
    </p>
    <p class="line-info">使用日期：{{ detailInfo.StartTime.slice(0, 11) }}</p>
    <p class="line-info">
      使用时间：{{ detailInfo.StartTime.slice(11, 16) }} 至 {{ detailInfo.EndTime.slice(11, 16) }}
    </p>
    <p class="line-info">使用时长：{{ detailInfo.UseTime }}</p>
    <p class="line-info">使用人数：{{ detailInfo.UseNum }}</p>
    <p class="line-info">申请时间：{{ detailInfo.CreateByDate.slice(0, 16) }}</p>
    <p class="line-info">预约说明：{{ detailInfo.ReservIntroduction }}</p>
    <div class="btn-line">
      <van-button type="default" @click="goBack">返回</van-button>
      <van-button
        type="primary"
        style="margin-left: 40px"
        v-if="detailInfo.ReservationState === 1"
        @click="revokeConfirm"
        >撤销</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "VenueMyAppointmentDetail",
  data() {
    return {
      detailInfo: {
        BuildingName: "",
        CreateByDate: "",
        EndTime: "",
        Floor: "",
        FullName: "",
        HouseName: "",
        ReservIntroduction: "",
        ReservationID: "",
        ReservationState: "",
        SchoolDistrictName: "",
        StartTime: "",
        UseNum: "",
        UseTime: "",
        Volume: ""
      }
    };
  },
  created() {
    this.getInfo(this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    revokeConfirm() {
      this.xy.confirm("撤销提示？", "您确定要撤销吗？", this.revoke);
    },
    async revoke() {
      let params = {
        reservationID: this.$route.params.id
      };
      let res = await this.xyapi.get(this.$store.state.apiPath + "/api/Reservation/Cancel", params);
      if (res.success) {
        this.$router.back();
      }
    },
    async getInfo(id) {
      let params = {
        id
      };
      let res = await this.xyapi.get(this.$store.state.apiPath + "/api/Reservation/Get", params);
      if (res.success) {
        res.data ? (this.detailInfo = res.data) : "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.venue-Detail {
  background: #ffffff;
  padding: 20px 20px 40px;
  .btn-line {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  h3 {
    font-size: 36px;
    font-weight: bold;
    padding-bottom: 30px;
    span {
      font-weight: normal;
      font-size: 28px;
    }
  }
  .line-info {
    padding-bottom: 30px;
    font-size: 28px;
  }
}
</style>
